module.exports = __webpack_public_path__ + "static/media/plus.735946e5.svg";